import CardSection from "../../../../conponents/CardSection/CardSection";
import ImagePicker from "../../../../conponents/ImagePicker/ImagePicker";
import useExpenseLimits from "../../hooks/useExpenseLimits.js";
import styles from "./ExpenseReceiptSection.module.css";
import { useState } from "react";
import UpgradeBottomSheet from "../../../../conponents/UpgradeBottomSheet/UpgradeBottomSheet";
import { useSelector } from "react-redux";



const ExpenseReceiptSection = ({

    values,

    setFieldValue,

}) => {

    const user = useSelector((state) => state.user.user);

    const {

        loading,

        canAttach,

        remainingAttachments,

    } = useExpenseLimits(user);

    const [showUpgrade, setShowUpgrade] = useState(false);

    const handleBlocked = () => {

        setShowUpgrade(true);

    };

    return (

        <>

            <CardSection title="فاکتور هزینه">

                {

                    !loading && (

                        canAttach ? (

                            <div

                                className={`${styles.info}

                                ${remainingAttachments <= 3

                                    ? styles.warning

                                    : ""}`}

                            >

                                {

                                    remainingAttachments === Number.MAX_SAFE_INTEGER

                                        ? "ثبت تصویر بدون محدودیت امکان‌پذیر است."

                                        : `امکان ثبت ${remainingAttachments} تصویر دیگر وجود دارد.`

                                }

                            </div>

                        ) : (

                            <div className={styles.limitBox}>

                                <div className={styles.limitTitle}>

                                    محدودیت ثبت تصویر

                                </div>

                                <div className={styles.limitText}>

                                    سقف مجاز نسخه رایگان برای ثبت تصاویر تکمیل شده است.

                                    برای ثبت تصاویر بیشتر، اشتراک حرفه‌ای تهیه کنید.

                                </div>

                            </div>

                        )

                    )

                }

                <ImagePicker

                    label="تصویر فاکتور (اختیاری)"

                    value={values.imageFile}

                    preview={values.imageUrl}

                    showPreview={true}

                    canSelect={

                        canAttach ||
                    
                        Boolean(values.imageUrl)
                    
                    }

                    onBlocked={handleBlocked}

                    onChange={(file) =>

                        setFieldValue(

                            "imageFile",

                            file

                        )

                    }

                />

            </CardSection>

            <UpgradeBottomSheet

                open={showUpgrade}

                title="محدودیت ثبت تصویر"

                message="در نسخه رایگان فقط ۱۰ تصویر قابل ثبت است."

                onClose={() =>

                    setShowUpgrade(false)

                }

            />

        </>

    );

};

export default ExpenseReceiptSection;